import BaseInput from '@/libs/vue-argon-dashboard-pro-master/src/components/Inputs/BaseInput.vue';
import BaseDropdown from '@/libs/vue-argon-dashboard-pro-master/src/components/BaseDropdown.vue';
import Card from '@/libs/vue-argon-dashboard-pro-master/src/components/Cards/Card.vue';
import Modal from '@/libs/vue-argon-dashboard-pro-master/src/components/Modal.vue';
import StatsCard from '@/libs/vue-argon-dashboard-pro-master/src/components/Cards/StatsCard.vue';
import BaseButton from '@/libs/vue-argon-dashboard-pro-master/src/components/BaseButton.vue';
import Badge from '@/libs/vue-argon-dashboard-pro-master/src/components/Badge.vue';
import RouteBreadcrumb from '@/libs/vue-argon-dashboard-pro-master/src/components/Breadcrumb/RouteBreadcrumb';
import BaseCheckbox from '@/libs/vue-argon-dashboard-pro-master/src/components/Inputs/BaseCheckbox.vue';
import BaseSwitch from '@/libs/vue-argon-dashboard-pro-master/src/components/BaseSwitch.vue';
import BaseRadio from "@/libs/vue-argon-dashboard-pro-master/src/components/Inputs/BaseRadio";
import BaseProgress from "@/libs/vue-argon-dashboard-pro-master/src/components/BaseProgress";
import BasePagination from "@/libs/vue-argon-dashboard-pro-master/src/components/BasePagination";
import BaseAlert from "@/libs/vue-argon-dashboard-pro-master/src/components/BaseAlert";
import BaseNav from "@/libs/vue-argon-dashboard-pro-master/src/components/Navbar/BaseNav";
import BaseHeader from '@/libs/vue-argon-dashboard-pro-master/src/components/BaseHeader';
import { Input, Tooltip, Popover } from 'element-ui';
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(Card.name, Card);
    Vue.component(Modal.name, Modal);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component(RouteBreadcrumb.name, RouteBreadcrumb);
    Vue.component(Input.name, Input);
    Vue.use(Tooltip);
    Vue.use(Popover);
  }
};

export default GlobalComponents;
